const isProd = process.env.NODE_ENV === "production";

const apiUrl =
  process.env.NEXT_PUBLIC_API_URL ||
  (isProd ? "https://api-sales.asksystemsai.com" : "http://localhost:8081");

export default apiUrl;
